import Indefinable from './indefinable';

export default Indefinable;
